export const SET_FORM = 'SET_FORM'

export const SET_TAKEAWAY_WAITING_BASKET = 'SET_TAKEAWAY_WAITING_BASKET'
export const UPDATE_PARAMS = 'UPDATE_PARAMS'
export const UPDATE_PACKAGES = 'UPDATE_PACKAGES'
export const UPDATE_PROMOCODES = 'UPDATE_PROMOCODES'

export const REGISTER_USER = 'REGISTER_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_ID = 'UPDATE_USER_ID'
export const UPDATE_TEL = 'UPDATE_TEL'
export const UPDATE_NAME = 'UPDATE_NAME'
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS'
export const UPDATE_FLOOR_ROOM = 'UPDATE_FLOOR_ROOM'
export const UPDATE_COMPANY_BUILDING = 'UPDATE_COMPANY_BUILDING'
export const UPDATE_DISTRICT = 'UPDATE_DISTRICT'
export const UPDATE_LAT = 'UPDATE_LAT'
export const UPDATE_LNG = 'UPDATE_LNG'
export const UPDATE_PASSCODE = 'UPDATE_PASSCODE'

export const UPDATE_DELIVERY_ADDRESS = 'UPDATE_DELIVERY_ADDRESS'
export const UPDATE_NEED_TABLEWARE = 'UPDATE_NEED_TABLEWARE'
export const UPDATE_PROMO_CODE = 'UPDATE_PROMO_CODE'
export const GET_MERCHANT = 'GET_MERCHANT'

export const GET_CATEGORIES = 'GET_CATEGORIES'
export const SELECT_CATEGORY = 'SELECT_CATEGORY'
export const SELECT_SET_CATEGORY = 'SELECT_SET_CATEGORY'

export const RESET_MENUSCACHE = 'RESET_MENUSCACHE'
export const GET_COMMODITIES = 'GET_COMMODITIES'
export const GET_MENUS = 'GET_MENUS'
export const UPDATE_FORCE_REFRESH_MENU = 'UPDATE_FORCE_REFRESH_MENU'

export const GET_TAGS = 'GET_TAGS'
export const SELECT_TAG = 'SELECT_TAG'

export const GET_ORDERS = 'GET_ORDERS'
export const REQUEST_SERVICE = 'REQUEST_SERVICE;'

export const SET_IS_TAKE_AWAY = 'SET_IS_TAKE_AWAY'
export const SET_IS_DELIVERY = 'SET_IS_DELIVERY'
export const SET_IS_SHOP = 'SET_IS_SHOP'
export const SET_IS_STORE_DELIVERY = 'SET_IS_STORE_DELIVERY'
export const SET_SHIPPING = 'SET_SHIPPING'

export const SET_CARD_ONLY = 'SET_CARD_ONLY'

export const GET_ACTIVE_TABLES = 'GET_ACTIVE_TABLES'
export const GET_ACTIVE_TABLES_ORDERS = 'GET_ACTIVE_TABLES_ORDERS'
export const UPDATE_SELECTED_TABLE = 'UPDATE_SELECTED_TABLE'

/**
 * NavBar
 */
export const SWITCH_RIGHT_SIDEBAR = 'SWITCH_RIGHT_SIDEBAR'
export const SWITCH_EDIT_MODE = 'SWITCH_EDIT_MODE'
export const SWITCH_CLEAR_ALL_ORDERS = 'SWITCH_CLEAR_ALL_ORDERS'
export const IS_STICKY_NAVBAR_SWIPER = 'IS_STICKY_NAVBAR_SWIPER'

/**
 * Checkout
 */
export const ADD_STASH = 'ADD_STASH'
export const RESET_STASH = 'RESET_STASH'
export const UPDATE_STASH = 'UPDATE_STASH'
export const ADD_STASH_BY_OPTION_GROUP = 'ADD_STASH_BY_OPTION_GROUP'
export const REMOVE_STASH_BY_OPTION_GROUP = 'REMOVE_STASH_BY_OPTION_GROUP'
export const RESET_STASH_BY_OPTION_GROUP = 'RESET_STASH_BY_OPTION_GROUP'
export const ADD_STASH_BY_RADIO_GROUP = 'ADD_STASH_BY_RADIO_GROUP'
export const RESET_STASH_BY_RADIO_GROUP = 'RESET_STASH_BY_RADIO_GROUP'

export const ADD_ORDER = 'ADD_ORDER'
export const CANCEL_ORDER = 'CANCEL_ORDER'
export const DELETE_ORDER_BY_DISH_ID = 'DELETE_ORDER_BY_DISH_ID'
export const UPDATE_ORDER = 'UPDATE_ORDER'
export const UPDATE_SET_ORDER_CONFIRMED_STATUS = 'UPDATE_SET_ORDER_CONFIRMED_STATUS'
export const UPDATE_ORDER_REMARK = 'UPDATE_ORDER_REMARK'
export const RESET_ORDER = 'RESET_ORDER'
export const UPDATE_CAN_PAY = 'UPDATE_CAN_PAY'

export const REQUEST_CREATE_BASKET = 'REQUEST_CREATE_BASKET'
export const CREATE_BASKET = 'CREATE_BASKET'
export const ADD_BASKET = 'ADD_BASKET'
export const RESET_BASKET = 'RESET_BASKET'
export const CLEAR_BASKET = 'CLEAR_BASKET'
export const SET_TAKEAWAY_STATUS = 'SET_TAKEAWAY_STATUS'

export const PAY_ORDER = 'PAY_ORDER'
export const UPDATE_SET_STEP = 'UPDATE_SET_STEP'
export const UPDATE_SEARCHMDOE_DISPLAY = 'UPDATE_SEARCHMDOE_DISPLAY'
export const SET_FILTERED_BY_ME = 'SET_FILTERED_BY_ME'

// > export const COMPLETE_TAKEAWAY_ORDER = 'COMPLETE_TAKEAWAY_ORDER'
/**
 * Stepper
 */
export const SWITCH_BOTTOM_SHEET = 'SWITCH_BOTTOM_SHEET'
export const ACTIVE_BOTTOM_SHEET_SUBMIT_BUTTON = 'ACTIVE_BOTTOM_SHEET_SUBMIT_BUTTON'
export const NAV_BAR_SWIPER_EXPANDED = 'NAV_BAR_SWIPER_EXPANDED'
export const GET_ITEM_OPTIONS = 'GET_ITEM_OPTIONS'

/**
 * Locale
 */
export const SWITCH_LOCALE = 'SWITCH_LOCALE'
export const SET_USER_LOCALE = 'SET_USER_LOCALE'
export const SET_TAKEAWAY_ORDERS = 'SET_TAKEAWAY_ORDERS'
export const SET_TAKEAWAY_AVAILABLE = 'SET_TAKEAWAY_AVAILABLE'
export const SET_OUT_TRADE_NO = 'SET_OUT_TRADE_NO'
export const SET_DELIVERY_AVAILABLE = 'SET_DELIVERY_AVAILABLE'
export const SET_TAKEAWAY_DISCOUNT = 'SET_TAKEAWAY_DISCOUNT'
export const REDEEM_PROMO_CODE = 'REDEEM_PROMO_CODE'
export const REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE'
export const UPDATE_PER_ITEM_REMARK = 'UPDATE_PER_ITEM_REMARK'
export const REMOVE_PER_ITEM_REMARK = 'REMOVE_PER_ITEM_REMARK'

/**
 * Sold Out
 */
export const UPDATE_SOLD_OUT_ITEMS = 'UPDATE_SOLD_OUT_ITEMS'
export const UPDATE_SOLD_OUT_CAN_CONTINUE_ACTION = 'UPDATE_SOLD_OUT_CAN_CONTINUE_ACTION'
export const UPDATE_SOLD_OUT_INVENTORY = 'UPDATE_SOLD_OUT_INVENTORY'
export const UPDATE_DISPLAY_SOLD_OUT_DIALOG_FOOTER = 'UPDATE_DISPLAY_SOLD_OUT_DIALOG_FOOTER'
export const UPDATE_DISPLAY_SOLD_OUT_DIALOG_TAKEAWAY_PAYMENT_SUMMARY = 'UPDATE_DISPLAY_SOLD_OUT_DIALOG_TAKEAWAY_PAYMENT_SUMMARY'

/**
 * Directory
 */
export const INIT_DIRECTORY_PAGE = 'INIT_DIRECTORY_PAGE'
export const UPDATE_SCALE = 'UPDATE_SCALE'
export const UPDATE_DISPLAY_NAVBAR_MENU = 'UPDATE_DISPLAY_NAVBAR_MENU'
export const UPDATE_DISPLAY_SHARE_DIALOG = 'UPDATE_DISPLAY_SHARE_DIALOG'
export const UPDATE_DISPLAY_COVER_IMAGE = 'UPDATE_DISPLAY_COVER_IMAGE'
export const UPDATE_DISPLAY_INTRO = 'UPDATE_DISPLAY_INTRO'
export const UPDATE_SELECTED_DATE = 'UPDATE_SELECTED_DATE'
export const UPDATE_SELECTED_TIME = 'UPDATE_SELECTED_TIME'
export const UPDATE_SELECTED_SHIPPING = 'UPDATE_SELECTED_SHIPPING'
export const UPDATE_DISPLAY_BACKDROP_LOADING = 'UPDATE_DISPLAY_BACKDROP_LOADING'
export const UPDATE_DISPLAY = 'UPDATE_DISPLAY'

/**
 * Campaign
 */
export const UPDATE_DISPLAY_CCB_CARD_ONLY_DIALOG = 'UPDATE_DISPLAY_CCB_CARD_ONLY_DIALOG'
export const UPDATE_FLOOR = 'UPDATE_FLOOR'

/**
 * Waiter
 */
export const RESET_WAITER_NUMBER_PAD = 'RESET_WAITER_NUMBER_PAD'
export const RESET_WAITER_NUMBER_PAD_VALUE = 'RESET_WAITER_NUMBER_PAD_VALUE'
export const UPDATE_DISPLAY_WAITER_NUMBER_PAD = 'UPDATE_DISPLAY_WAITER_NUMBER_PAD'
export const UPDATE_WAITER_NUMBER_PAD_VALUE = 'UPDATE_WAITER_NUMBER_PAD_VALUE'



// WEBPACK FOOTER //
// ./src/constants/actionType.js